module.exports = __webpack_public_path__ + "img/0220624173559.d3a8e231.png";